/**
 * Loads the Maps JavaScript API with Places so react-places-autocomplete works.
 * The key must come from import.meta.env — index.html placeholders like %VITE_*% are not
 * reliably substituted when vite-plugin-html processes the file, which breaks autocomplete.
 */
export function loadGoogleMapsScript(): void {
  const key = import.meta.env.VITE_MAPS_API_KEY;
  if (!key || String(key).trim() === '') {
    if (import.meta.env.DEV) {
      console.warn('[boapp] VITE_MAPS_API_KEY is missing; address autocomplete will not work.');
    }
    return;
  }

  if (document.querySelector('script[data-boapp-google-maps]')) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('data-boapp-google-maps', '1');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(String(key))}&libraries=places&loading=async`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}
